
// import { useEffect, useState } from "react";
// import { jwtDecode } from "jwt-decode";
// import { sidebar_data_access } from "../../../feature-module/Services/ApiCalling";
// import { all_routes } from "../../../feature-module/router/all_routes";

// const routes = all_routes;

// export const SidebarDataTest = () =>{

//   const [menu, setMenu] = useState([]);
//   const [userRole, setUserRole] = useState(null);

//   useEffect(() => {
//     const token = localStorage.getItem("LoginToken");
//     if (!token) return;

//     const decoded = jwtDecode(token);
//     const role = decoded?.Role_Identifiers?.[0];
//     setUserRole(role);

//     sidebar_data_access(token)
//       .then((res) => {
//         if (res?.Success && res?.menuSubmenuDetails) {
//           const filteredMenu = filterMenuByRole(res.menuSubmenuDetails, role);
//           setMenu(filteredMenu);
//           console.log("Sidebar API response:", res);
//         }
//       })
//       .catch((err) => {
//         console.error("Failed to fetch sidebar:", err);
//       });
//   }, []);

//   const filterMenuByRole = (menuItems, role) => {
//     return menuItems
//       .filter((item) => item.Is_Enable === "Y" && item.ROLE_ID.includes(role))
//       .map((item) => ({
//         tittle: item.TITLE,
//         icon: item.ICON || "menu",
//         showAsTab: item.SHOW_AS_TAB === "TRUE",
//         separateRoute: item.SEPRATE_ROUTE === "TRUE",
//         submenuItems: (item.subMenus || [])
//           .filter(
//             (sub) => sub.Is_Enable === "Y" && sub.ROLE_ID.includes(role)
//           )
//           .map((sub) => ({
//             label: sub.TITLE,
//             link: resolveRoute(sub.ROUTE_LINK),
//             submenu: sub.SUB_MENU === "TRUE",
//             showSubRoute: sub.SHOW_AS_TAB === "TRUE",
//             icon: sub.ICON || "dot",
//             base: "",
//           })),
//       }));
//   };

//   const resolveRoute = (routeLink) => {


//     // const baseUrl = "http://localhost:3000/cluster/web";        // localhost
//     //  const baseUrl = "https://cluster-web.thesaicomputers.com/pvvnl";         / /pvvnl
//     //  const baseUrl = "https://cluster-web.thesaicomputers.com/dvvnl";       // dvvnl
//     // const baseUrl = "https://cluster-web.thesaicomputers.com/kesco";         // kesco
//     const baseUrl = "https://sit-cluster.thesaicomputers.com/cluster/web"          // sit

//     if (!routeLink) return "/";

//     try {



//       const cleanPath = routeLink.replace(/^\/+/, "");

//       return `${baseUrl}/${cleanPath}`;

//     } catch (err) {

//       console.error("Invalid routeLink in resolveRoute:", routeLink, err);

//       return "/";

//     }

//   };

//   return menu;
// };

import { useEffect, useState } from "react";
import { all_routes } from "../../../feature-module/router/all_routes";
import { jwtDecode } from "jwt-decode";
const routes = all_routes;

export const SidebarDataTest = () => {


  return [

    {
      tittle: '',
      icon: 'airplay',
      showAsTab: false,
      separateRoute: false,
      submenuItems: [
        {
          label: 'Meeting Form',
          link: routes.meetingFormView,
          external: false,
          submenu: false,
          showSubRoute: false,
          icon: 'bolt',
          base: '',
        },
        {
          label: 'Meeting Summary',
          // link: routes.MeetingSummeryView,
          link: "http://15.207.162.165:8501/dashboard/",
          external: true,
          submenu: false,
          showSubRoute: false,
          icon: 'bolt',
          base: '',
        },
      ],
    },


    // (userRole === 'STINCHHO') && {
    //   tittle: 'Reports',
    //   icon: 'airplay',
    //   showAsTab: true,
    //   separateRoute: false,
    //   submenuItems: [
    //     {
    //       label: 'Reports',
    //       link: 'index',
    //       submenu: true,
    //       showSubRoute: true,
    //       icon: 'bolt',
    //       base: 'Data_Reports',
    //       // materialicons: 'start',
    //       // dot: true,
    //       submenuItems: [
    //         {
    //           label: "Billed Exception",
    //           link: routes.billedExceptionView,
    //           base: 'Data_Reports',
    //         },
    //         {
    //           label: "Unbilled Exception",
    //           link: routes.unbilledExceptionView,
    //           base: 'Data_Reports',
    //         },
    //         {
    //           label: "Reading Defective (RDF)",
    //           link: routes.readingDefectiveView,
    //           base: 'Data_Reports',
    //         },
    //         {
    //           label: "Ceiling Defective (CDF)",
    //           link: routes.ceilingDefectiveView,
    //           base: 'Data_Reports',
    //         },
    //       ],
    //     },
    //   ],
    // },

  ].filter(Boolean); // <--- FILTERS OUT `false` values
}


